import React, { useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../Routes/BaseUrl";
import { toast } from "react-toastify";

export const GeneralInfoForm = () => {
  const Navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    title: "",
    specialization: "",
    experience: 0,
    gender: "",
    dateOfBirth: "",
    aadhaarNumber: "",
    degree: "",
    collegeUniversity: "",
    year: 0,
    city: "",
    colonyStreetLocality: "",
    country: "",
    pinCode: "",
    state: "",
    registrationNumber: "",
    registrationCouncil: "",
    registrationYear: 0,
    aadhaarOtp: "",
    aadhaarTxnId: "",
  });
 
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  useEffect(() => {
    if (id) {
      fetchDoctorData();
    }
  }, [id]);

  const fetchDoctorData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${BaseUrl.trim()}/doctor/getDoctorProfileById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const doctor = response.data.data;

      const populatedData = {
        fullName: doctor.personalDetails?.fullName || "",
        email: doctor.emailId || "",
        mobile: doctor.mobileNumber || "",
        title: doctor.personalDetails?.title || "",
        specialization: doctor.systemOfMedicine?.systemOfMedicine || "",
        experience: doctor.experience || 0,
        gender: doctor.personalDetails?.gender || "",
        dateOfBirth: doctor.personalDetails?.dob ? moment(doctor.personalDetails.dob, "DD-MM-YYYY").format("YYYY-MM-DD") : "",
        aadhaarNumber: doctor.personalDetails?.aadhaarNumber || "",
        degree: doctor.qualificationDetails?.degreeName || "",
        collegeUniversity: doctor.qualificationDetails?.college || "",
        year: doctor.qualificationDetails?.passingYear || 0,
        city: doctor.addressPerKyc?.district || "",
        colonyStreetLocality: doctor.addressPerKyc?.address || "",
        country: doctor.addressPerKyc?.country || "",
        pinCode: doctor.addressPerKyc?.pincode || "",
        state: doctor.addressPerKyc?.state || "",
        registrationNumber: doctor.registrationDetails?.registrationNumber || "",
        registrationCouncil: doctor.registrationDetails?.registerWithCouncil || "",
        registrationYear: doctor.registrationDetails?.dateOfRegistration ? moment(doctor.registrationDetails.dateOfRegistration).format("YYYY") : 0,
        aadhaarOtp: "",
        aadhaarTxnId: "",
      };
      
      console.log("Populated Form Data:", populatedData); // ADD THIS
      setFormData(populatedData);

      setCurrentStep(3);
    } catch (error) {
      console.error("Error fetching doctor data:", error);
      toast.error("Failed to load doctor data.");
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validateMobile = (mobile) => {
    const re = /^[0-9]{10}$/;
    return re.test(String(mobile));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Email is not valid";
    }
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Mobile number is not valid";
    }
    if (!formData.aadhaarNumber) {
      newErrors.aadhaarNumber = "Aadhaar Number is required";
    } else if (!/^\d{12}$/.test(String(formData.aadhaarNumber))) {
      newErrors.aadhaarNumber = "Aadhaar Number must be 12 digits";
    }
    if (currentStep === 2) {
      if (!formData.aadhaarOtp)
        newErrors.aadhaarOtp = "Aadhaar OTP is required";
    }
    if (currentStep === 3) {
      if (!formData.title) newErrors.title = "Title is required";
      if (!formData.fullName) newErrors.fullName = "fullName is required";
      if (!formData.specialization)
        newErrors.specialization = "Specialization is required";
      if (!formData.experience) newErrors.experience = "Experience is required";
      if (!formData.gender) newErrors.gender = "Gender is required";
      if (!formData.dateOfBirth)
        newErrors.dateOfBirth = "Date of Birth is required";
      if (!formData.degree) newErrors.degree = "Degree is required";
      if (!formData.collegeUniversity)
        newErrors.collegeUniversity = "College/University is required";
      if (!formData.year) newErrors.year = "Year of Graduation is required";
      if (!formData.city) newErrors.city = "City is required";
      if (!formData.colonyStreetLocality)
        newErrors.colonyStreetLocality = "Colony/Street/Locality is required";
      if (!formData.country) newErrors.country = "Country is required";
      if (!formData.pinCode) newErrors.pinCode = "Pin Code is required";
      if (!formData.state) newErrors.state = "State is required";
      if (!formData.registrationNumber)
        newErrors.registrationNumber = "Registration Number is required";
      if (!formData.registrationCouncil)
        newErrors.registrationCouncil = "Registration Council is required";
      if (!formData.registrationYear)
        newErrors.registrationYear = "Registration Year is required";

      setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form submitted!"); // ADD THIS
  console.log("Current Step:", currentStep); // ADD THIS
  console.log("Doctor ID:", id); // ADD THIS
  console.log("Form Data:", formData); // ADD THIS

  if (!validateForm()) {
    console.log("Validation failed!"); // ADD THIS
    console.log("Errors:", errors); // ADD THIS
    return;
  }
  
  console.log("Validation passed!"); // ADD THIS

    try {
      if (currentStep === 1) {
        setIsSendingOtp(true);
        const response = await axios.post(
          BaseUrl.trim() + `/doctor/doctorCreate`,
          {
            aadhaarNumber: formData.aadhaarNumber,
          }
        );
        const txnId = response?.data?.txnId || response?.data?.data?.txnId;
        if (!txnId) {
          toast.error("OTP sent but transaction ID is missing.");
          return;
        }
        setFormData((prev) => ({ ...prev, aadhaarTxnId: txnId }));
        setCurrentStep(2);
      } else if (currentStep === 3) {
         console.log("Entering step 3 - Update mode"); // ADD THIS
        if (id) {
          console.log("ID exists, calling update API"); // ADD THIS
        console.log("Update URL:", `${BaseUrl.trim()}/doctor/doctorProfileUpdate/${id}`); // ADD THIS
          const response = await axios.put(
            `${BaseUrl.trim()}/doctor/doctorProfileUpdate/${id}`,
            {
              fullName: formData.fullName,
              title: formData.title,
              specialization: formData.specialization,
              experience: formData.experience,
              gender: formData.gender,
              dateOfBirth: formData.dateOfBirth,
              degree: formData.degree,
              collegeUniversity: formData.collegeUniversity,
              year: formData.year,
              city: formData.city,
              colonyStreetLocality: formData.colonyStreetLocality,
              country: formData.country,
              pinCode: formData.pinCode,
              state: formData.state,
              registrationNumber: formData.registrationNumber,
              registrationCouncil: formData.registrationCouncil,
              registrationYear: formData.registrationYear,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log("Update Response:", response);
          if (response.status === 200) {
            toast.success("Profile Updated successfully.");
            Navigate("/DoctorList")
          }
        } else {
          // CREATE MODE
          const response = await axios.post((BaseUrl.trim() + `/doctor/doctorProfile`), {
            fullName: formData.fullName,
            email: formData.email,
            mobile: formData.mobile,
            title: formData.title,
            specialization: formData.specialization,
            experience: formData.experience,
            gender: formData.gender,
            dateOfBirth: formData.dateOfBirth,
            degree: formData.degree,
            collegeUniversity: formData.collegeUniversity,
            year: formData.year,
            city: formData.city,
            colonyStreetLocality: formData.colonyStreetLocality,
            country: formData.country,
            pinCode: formData.pinCode,
            state: formData.state,
            registrationNumber: formData.registrationNumber,
            registrationCouncil: formData.registrationCouncil,
            registrationYear: formData.registrationYear,
          });
          toast.success("Profile Created successfully");
        }
        Navigate("/DoctorList");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    } finally {
      if (currentStep === 1) {
        setIsSendingOtp(false);
      }
    }
  };

  const handleOTPVerification = async () => {
    if (!validateForm()) return;

    try {
      const response = await axios.post(BaseUrl.trim() + `/doctor/doctorVerify`, {
        otp: formData.aadhaarOtp,
        txnId: formData.aadhaarTxnId,
      });
      console.log(response);
      setCurrentStep(3);
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <>
            <h5 className="mb-4">General Information</h5>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter your full name"
                    value={formData.fullName}
                    onChange={(e) =>
                      setFormData({ ...formData, fullName: e.target.value })
                    }
                    isInvalid={!!errors.fullName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fullName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="mobile">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    required
                    type="tel"
                    placeholder="Enter your mobile number"
                    value={formData.mobile}
                    onChange={(e) =>
                      setFormData({ ...formData, mobile: e.target.value })
                    }
                    isInvalid={!!errors.mobile}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.mobile}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>{" "}
              <Col md={6} className="mb-3">
                <Form.Group id="aadhaarNumber">
                  <Form.Label>Aadhaar Number</Form.Label>
                  <Form.Control
                    required 
                    type="text"
                    placeholder="Enter your Aadhaar Number"
                    value={formData.aadhaarNumber}
                    onChange={(e) =>
                      setFormData({ ...formData, aadhaarNumber: e.target.value })
                    }
                    isInvalid={!!errors.aadhaarNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.aadhaarNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-3">
              <Button
                variant="primary"
                onClick={handleFormSubmit}
                disabled={isSendingOtp}
              >
                {isSendingOtp ? "Sending OTP..." : "OTP Send"}
              </Button>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <h5 className="mb-4">OTP Verification</h5>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="aadhaarOtp">
                  <Form.Label>Enter Aadhaar OTP</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter OTP received on Aadhaar"
                    value={formData.aadhaarOtp}
                    onChange={(e) =>
                      setFormData({ ...formData, aadhaarOtp: e.target.value })
                    }
                    isInvalid={!!errors.aadhaarOtp}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.aadhaarOtp}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-3">
              <Button variant="primary" onClick={handleOTPVerification}>
                Verify OTP
              </Button>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <h5 className="mb-4">{id ? "Edit Profile Information" : "Profile Information"}</h5>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="title">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    isInvalid={!!errors.title}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.title}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your Full Name"
                    value={formData.fullName}
                    onChange={(e) =>
                      setFormData({ ...formData, fullName: e.target.value })
                    }
                    isInvalid={!!errors.fullName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fullName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="specialization">
                  <Form.Label>Specialization</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your specialization"
                    value={formData.specialization}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        specialization: e.target.value,
                      })
                    }
                    isInvalid={!!errors.specialization}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.specialization}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="experience">
                  <Form.Label>Experience</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter your experience"
                    value={formData.experience}
                    onChange={(e) =>
                      setFormData({ ...formData, experience: e.target.value })
                    }
                    isInvalid={!!errors.experience}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.experience}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="gender">
                  <Form.Label>Gender</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your gender"
                    value={formData.gender}
                    onChange={(e) =>
                      setFormData({ ...formData, gender: e.target.value })
                    }
                    isInvalid={!!errors.gender}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.gender}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="dateOfBirth">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter your date of birth"
                    value={formData.dateOfBirth}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        dateOfBirth: e.target.value,
                      })
                    }
                    isInvalid={!!errors.dateOfBirth}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.dateOfBirth}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="degree">
                  <Form.Label>Degree</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your degree"
                    value={formData.degree}
                    onChange={(e) =>
                      setFormData({ ...formData, degree: e.target.value })
                    }
                    isInvalid={!!errors.degree}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.degree}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="collegeUniversity">
                  <Form.Label>College/University</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your college/university"
                    value={formData.collegeUniversity}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        collegeUniversity: e.target.value,
                      })
                    }
                    isInvalid={!!errors.collegeUniversity}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.collegeUniversity}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="year">
                  <Form.Label>Year of Graduation</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter your year of graduation"
                    value={formData.year}
                    onChange={(e) =>
                      setFormData({ ...formData, year: e.target.value })
                    }
                    isInvalid={!!errors.year}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.year}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your city"
                    value={formData.city}
                    onChange={(e) =>
                      setFormData({ ...formData, city: e.target.value })
                    }
                    isInvalid={!!errors.city}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.city}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="colonyStreetLocality">
                  <Form.Label>Colony/Street/Locality</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your colony/street/locality"
                    value={formData.colonyStreetLocality}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        colonyStreetLocality: e.target.value,
                      })
                    }
                    isInvalid={!!errors.colonyStreetLocality}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.colonyStreetLocality}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your country"
                    value={formData.country}
                    onChange={(e) =>
                      setFormData({ ...formData, country: e.target.value })
                    }
                    isInvalid={!!errors.country}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.country}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="pinCode">
                  <Form.Label>Pin Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your pin code"
                    value={formData.pinCode}
                    onChange={(e) =>
                      setFormData({ ...formData, pinCode: e.target.value })
                    }
                    isInvalid={!!errors.pinCode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pinCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your state"
                    value={formData.state}
                    onChange={(e) =>
                      setFormData({ ...formData, state: e.target.value })
                    }
                    isInvalid={!!errors.state}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.state}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="registrationNumber">
                  <Form.Label>Registration Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your registration number"
                    value={formData.registrationNumber}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        registrationNumber: e.target.value,
                      })
                    }
                    isInvalid={!!errors.registrationNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registrationNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="registrationCouncil">
                  <Form.Label>Registration Council</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your registration council"
                    value={formData.registrationCouncil}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        registrationCouncil: e.target.value,
                      })
                    }
                    isInvalid={!!errors.registrationCouncil}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registrationCouncil}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group id="registrationYear">
                  <Form.Label>Registration Year</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter your registration year"
                    value={formData.registrationYear}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        registrationYear: e.target.value,
                      })
                    }
                    isInvalid={!!errors.registrationYear}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registrationYear}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-3">
              <Button variant="primary" onClick={handleFormSubmit}>
                {id ? "Update Profile" : "Create Profile"}
              </Button>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <Form onSubmit={handleFormSubmit}>{renderStep()}</Form>
      </Card.Body>
    </Card>
  );
};
